module.exports = __webpack_public_path__ + "static/pak-gif-1-95dc683bcaf6a8c9c0ee7089cf48fe7b.gif";